import { BCTransfer } from '@bimser/components';
import { FormItemTypes, IDictionary, MLHelper } from '@bimser/core';
import { Map } from 'immutable';
import { JSX } from 'react';
import { IPropertyField } from '../../../../entities/common';
import ListBoxBase from '../../base/ListBoxBase';
import { getCultureEnumMembers } from '../../helper';
import Styles from './assets/styles.scss';
import { ITransferProperties } from './entities/ITransferProperties';
import { TransferDirection } from '@bimser/components/dist/BCTransfer/entities/ITransferProps';
import merge from 'lodash/merge';
export default class Transfer extends ListBoxBase {
	allowSelectAll: boolean;
	sourceTitle: IDictionary<string>;
	targetTitle: IDictionary<string>;

	constructor() {
		super();
		this.onSearchChange = this.onSearchChange.bind(this);

		this.controlType = FormItemTypes.EControlTypes.Transfer;

		this.items = [];
		this.allowSelectAll = false;
		this.sourceTitle = {};
		this.targetTitle = {};

		this.subscribe('trigger:OnValueChanged', (value: string) => {
			this.__proxyChanging.items = this.items.map(item =>
				merge(item, { selected: JSON.parse(value).includes(item.key) })
			);
		});
	}

	__loadProperties(data: ITransferProperties) {
		super.__loadProperties(data);

		this.__proxyChanged.allowSelectAll = data.allowSelectAll;
		this.__proxyChanged.sourceTitle = data.sourceTitle;
		this.__proxyChanged.targetTitle = data.targetTitle;
	}

	private triggerValueChanged(targetKeys: string[], direction: string, moveKeys: string[]) {
		if (targetKeys && targetKeys.length) {
			this.__proxyChanging.items = this.items.map((item, index) =>
				Object.assign({}, item, {
					selected:
						targetKeys.findIndex(i => i?.toString() === item.value?.toString()) > -1
				})
			);
		} else {
			this.__proxyChanging.items = this.items.map((item, index) =>
				Object.assign({}, item, { selected: false })
			);
		}
	}

	__getPropertyFields(properties?: Map<string, any>): IPropertyField[] {
		const fields = super.__getPropertyFields(properties);
		return [
			...fields,
			{
				name: 'allowSelectAll',
				type: 'boolean'
			},
			{
				name: 'sourceTitle',
				type: 'object',
				items: getCultureEnumMembers(true)
			},
			{
				name: 'targetTitle',
				type: 'object',
				items: getCultureEnumMembers(true)
			}
		];
	}

	__getItems(): any[] {
		if (this.items) {
			return this.items.map(item => ({
				key: item.value,
				title: item.text.getText(),
				args: null
			}));
		}
		return null;
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			allowSelectAll: this.allowSelectAll,
			sourceTitle: this.sourceTitle,
			targetTitle: this.targetTitle,
			options: this.items.map(i => {
				delete i['icon'];
				return { ...i, text: i.text.getText() };
			})
		};
	}

	private onSearchChange(direction: TransferDirection, value: string) {
		if (direction === 'left') {
			this.__onSearch(value);
		}
	}

	__render(children?: JSX.Element) {
		return super.__render(
			<>
				<BCTransfer
					dataSource={this.__getItems()}
					render={item => item.title}
					disabled={this.__isDisabled()}
					readOnly={this.__isReadOnly()}
					onChange={this.triggerValueChanged.bind(this)}
					targetKeys={this.items.filter(i => i.selected).map(i => i.value)}
					titles={[
						MLHelper.getMLText(this.sourceTitle),
						MLHelper.getMLText(this.targetTitle)
					]}
					showSearch={this.showSearch}
					showSelectAll={this.allowSelectAll}
					style={{ '--bgcolor': this.style.backgroundColor } as any}
					className={Styles.fillTransfer}
					onSearchChange={this.onSearchChange}
				/>
			</>
		);
	}
}
